<template>
  <a-card :bordered="false">
    <a-tabs
      default-active-key="1"
      :tab-position="top"
      @prevClick="callback"
      @nextClick="callback"
      @change="callback"
      v-show="isTrue == 1"
    >

      <a-tab-pane v-for="i in labelList" :key="i.installType" :tab="i.installName">
        <div class="table-page-search-wrapper">
          <a-form layout="inline"  @keyup.enter="queryList()">
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-item label="企业名称"  >
                  <a-input  v-model="queryParam.enterpriseName"/>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="品牌">
                  <a-select   v-model="queryParam.brandName" allowClear="true">
                    <a-select-option  v-for="type in data1" :key="type.brandName">{{type.brandName}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="型号">
                  <a-select   v-model="queryParam.modelName"  allowClear="true">
                    <a-select-option  v-for="type in data6" :key="type.accessorySpecification">{{type.accessorySpecification}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="订单类型">
                  <a-select  v-model="queryParam.orderType" allowClear="true">
                    <a-select-option  v-for="type in restaurantTypes" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="资料名称">
                  <a-input  v-model="queryParam.picAndVideo"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-divider/>
            <span class="table-page-search-submitButtons">
              <a-row>
                <a-col :span="5" :offset="19" :style="{ textAlign: 'right' }">
                  <a-button type="primary"  @click="piliang()">批量下载</a-button>
                </a-col>
              </a-row>
          </span>
          </a-form>
        </div>
      </a-tab-pane>
    </a-tabs>
    <div style="display: flex;flex-direction: row;flex-wrap:wrap;justify-content: left">
      <div style="display: flex;flex-direction: column;justify-content: center;margin: 60px"  v-for="item in infoList" :key="index" >
        <div>
          <div style="position: relative;margin: 10px;margin-bottom: 0px">
            <img @click="downLoadLIST(item)" draggable="false" src="../../assets/images/fa-folder-open.svg" style="position: absolute;left:80px;top:-8px">
            <img @click="editInfo(item)" draggable="false" src="../../assets/images/fa-folder-opened.svg">
          </div>
        </div>
        <div style="text-align: center">
          {{item.orderNo}}
        </div>
      </div>
    </div>
    <div v-show="isTrue == 2" style="text-align: center">
      <a-divider></a-divider>
      <span>暂无数据</span>
    </div>
    <data-bank-model ref="modal" @ok="handleOk"/>
  </a-card>
</template>
<script>
  import {databaseList} from '@/api/basicdatas/DataBank'
  import { getSelectBrand,selectAccessorySpecificationCombox} from '@/api/enterprise/accessory'
  import {getList} from '@/api/order/orderList'
  import { STable } from '@/components'
  import { deleteInstallLabel,queryInstallLabel,forbiddenInstallLabel,enableInstallLabel } from '@/api/master/LabelManagement'
  import DataBankModel from './modules/DataBankModel.vue'
  import { checkPermission } from '@/utils/permissions'
  import {ACCESS_TOKEN} from '@/store/mutation-types'

  const images= [
    'anzhuang.png',
    'baobiaoguanli-choose.png',
    'baobiaoguanli.png',
    'benyue-guanbi.png',
    'benyue-hexiao.png',
    'benyue-jie-dan.png',
    'benyue-jiesuan.png',
    'benyue-tuidan.png',
    'benyue-xiadan.png',
    'benyue-xiaodan.png',
    'caiwuguanli-choose.png',
    'caiwuguanli.png',
    'champion.png',
    'chaoshi.png',
    'dongjie.png',
    'download.png',
    'duizhang.png',
    'gongdanguanli-choose.png',
    'gongdanguanli.png',
    'hexiao.png',
    'huikuan.png',
    'jiaji.png',
    'jichushuju-choose.png',
    'jichushuju.png',
    'jie-dan.png',
    'jiedan.png',
    'jiesuan.png',
    'jinri-guanbidingdan.png',
    'jinri-hexiao.png',
    'jinri-jie-dan.png',
    'jinri-jiesuan.png',
    'jinri-tuidan.png',
    'jinri-xiadan.png',
    'jinri-xiaodan.png',
    'loginout.png',
    'paidan.png',
    'peixunguanli-choose.png',
    'peixunguanli.png',
    'second.png',
    'shenhe.png',
    'shifu-anzhuang.png',
    'shifu-chaoshi.png',
    'shifu-hedan.png',
    'shifu-jie-dan.png',
    'shifu-jiedan.png',
    'shifu-jiedanliang.png',
    'shifu-jiesuan.png',
    'shifu-yuyue.png',
    'suojiangguanli-choose.png',
    'suojiangguanli.png',
    'suoqiguanli-choose.png',
    'suoqiguanli.png',
    'third.png',
    'tousu.png',
    'weihuikuan.png',
    'wentifankui.png',
    'xiadan.png',
    'xiaodan.png',
    'xitongguanli-choose.png',
    'xitongguanli.png',
    'xitongshouye-choose.png',
    'xitongshouye.png',
    'xiugaimima.png',
    'yonghuxinxi.png',
    'yuyue.png',
    'yuyueshibai.png',
    'zanbuanzhuang.png',
    'zanbujiesuan.png',
    'zhiban.png',
    'zong-guanbidingdan.png',
    'zong-hexiao.png',
    'zong-jie-dan.png',
    'zong-jiesuan.png',
    'zong-tuidan.png',
    'zong-xiadan.png',
    'zong-xiaodan.png',
  ]

  export default {
    name: 'TableList',
    components: {
      STable,
      DataBankModel
    },
    data () {
      return {
        data1:[],
        data6:[],
        infoList:[],
        form: this.$form.createForm(this),
        mdl: {},
        images,
        restaurantTypes:[],
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          installType:'',
          orderType:'',
          enterpriseName:'',
          brandName:'',
          modelName:'',
          picAndVideo:''
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            align:'center',
          }, {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action'},
            align:'center',
          }, {
            title: '标签名称',
            dataIndex: 'installLabelName',
            align:'center',
          }, {
            title: '添加时间',
            dataIndex: 'createTime',
            align:'center',
          }, {
            title: '添加人',
            dataIndex: 'createByName',
            align:'center',
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        // loadData: parameter => {
        //   return queryInstallLabel(Object.assign(parameter, this.queryParam))
        // },
        labelList:[],
        isTrue:1,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        addEnable: checkPermission('enterprise:channel:add'),
        editEnabel: checkPermission('enterprise:channel:edit'),
        removeEnable: checkPermission('enterprise:channel:remove')
      }
    },
    filters: {},
    async created () {
      // document.body.addEventListener('keyup', e => {
      //   if (e.keyCode == 13) {
      //     this.queryList()
      //   }
      // })

      getSelectBrand().then(res=>{
        console.log(res.data)
        this.data1 = res.data
      })
      selectAccessorySpecificationCombox().then(res=>{
         console.log(res.data)
        this.data6 = res.data
      })
      queryInstallLabel().then(res=>{
        console.log(res.rows)
        this.labelList = res.rows
        getList(res.rows[0].installType).then(res => {
          if (res.code === 0) {
            this.restaurantTypes = res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
        this.queryParam.installType=res.rows[0].installType
        databaseList(this.queryParam).then(res=>{
          console.log(res)
          if(res.rows.length>0){
            this.infoList=res.rows
          }else{
            this.$message.error('暂无数据')
            this.infoList=[]
          }
        })
      })

    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    methods: {
      piliang() {
        let files = [] // 所有文件

        console.log(this.infoList)
        for (var i = 0; i < this.infoList.length; i++) {
          for(var j=0;j<this.infoList[i].previewFileList.length;j++){
             files.push(this.infoList[i].previewFileList[j].url)
          }
        }
       console.log(files)
        if(files.length>0){
          files.forEach(url => {
            let a = document.createElement('a') // 创建a标签
            let e = document.createEvent('MouseEvents') // 创建鼠标事件对象
            e.initEvent('click', false, false) // 初始化事件对象
            a.href = url // 设置下载地址
            a.target='_blank'
            a.download = '' // 设置下载文件名
            a.dispatchEvent(e)
          })
        }
      },
      downLoadLIST(record){
        let files = [] // 所有文件
        console.log(record.previewFileList)
        for(var i=0;i<record.previewFileList.length;i++){
          files.push(record.previewFileList[i].url)
        }
         console.log(files)
        files.forEach(url => {
            let a = document.createElement('a') // 创建a标签
            let e = document.createEvent('MouseEvents') // 创建鼠标事件对象
            e.initEvent('click', false, false) // 初始化事件对象
            console.log(process.env.VUE_APP_API_BASE_URL, url)
            a.href = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + url // 设置下载地址
            a.target='_blank'
            a.download = '' // 设置下载文件名
            a.dispatchEvent(e)
        })
      },
      editInfo(record){
        console.log(record)
        this.$refs.modal.edit(record)
      },
      onChange1(value, dateString) {
        console.log('Selected Time: ', value);
        console.log('Formatted Selected Time: ', dateString);
        this.queryParam.createStartTime=dateString[0]
        this.queryParam.createEndTime=dateString[1]
      },
      onChange2(date,dateString) {
        // console.log(dateString)
        this.queryParam.endTime=dateString
      },
      handleChange1 (value) {
        // console.log(`selected ${value}`)
        this.queryParam.importance=value
      },
      clearValues() {
        this.queryParam={}
        this.queryParam.createStartTime=''
        this.queryParam.createEndTime=''
        console.log(this.queryParam)
      },
      onOk1(value) {
        // console.log('onOk: ', value);
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit (record) {
        console.log(record)
        this.$refs.modal.edit(record)
      },
      queryList () {
        databaseList(this.queryParam).then(res=>{
          console.log(res)
          if(res.rows.length>0){
            this.infoList=res.rows
          }else{
            this.$message.error('暂无数据')
            this.infoList=[]
          }
        })
      },
      callback(val) {
        console.log(val);
        getList(val).then(res => {
          if (res.code === 0) {
            this.restaurantTypes = res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
        this.queryParam.installType=val
        databaseList(this.queryParam).then(res=>{
          console.log(res.rows)
          if(res.rows.length>0){
            this.infoList=res.rows
          }else{
            this.$message.error('暂无数据')
            this.infoList=[]
          }
        })
      },
      showState (installLabelId, forbiddenStatus) {
        if (forbiddenStatus == 0) {
          forbiddenInstallLabel({ 'installLabelId': installLabelId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (forbiddenStatus == 1) {
          enableInstallLabel({ 'installLabelId': installLabelId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      delByIds (id) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            deleteInstallLabel({ 'installLabelId': id }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script>

<style scoped>
  .twobtn{
    background-color: #409EFF;
    color: white;
    width: 110px;
    font-size: 15px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  padding: 4px 16px;}
</style>
